import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { BundleLineItemType } from '../__generated__/sharedTypes.js';

const upperFirst = (value)=>{
    return value[0].toUpperCase() + value.slice(1);
};
const mapToProductType = (lineItemRaw)=>{
    //TODO: Fix it properly with ticket
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(lineItemRaw.bundleLineItemsType){
        case BundleLineItemType.CONTACT_LENSES_BENELUX:
        case BundleLineItemType.CONTACT_LENSES_SUBSCRIPTION:
            return 'Contact-lenses';
        case BundleLineItemType.NON_PRESCRIPTION_BUNDLE:
        case BundleLineItemType.PRESCRIPTION_GLASSES:
            const mainLineItem = lineItemRaw.bundleLineItems.find((l)=>l.isMainBundleLineItem
            );
            const productType = mainLineItem === null || mainLineItem === void 0 ? void 0 : mainLineItem.legacyProduct.productType;
            if (!productType) {
                return null;
            }
            const capitalized = upperFirst(productType);
            if (!CommerceToolsApi.isProductTypeName(capitalized)) {
                return null;
            }
            return capitalized;
    }
    return null;
};
const getProductUrl = (productLinkFormatter, lineItemRaw, slug, locale)=>{
    if (!slug || !productLinkFormatter) {
        return undefined;
    }
    if (lineItemRaw.__typename === 'LineItemBundle') {
        const productType = mapToProductType(lineItemRaw);
        if (!productType) {
            return undefined;
        }
        return productLinkFormatter({
            [locale]: slug
        }, lineItemRaw.sku, productType);
    }
    return productLinkFormatter({
        [locale]: slug
    }, lineItemRaw.sku, upperFirst(lineItemRaw.legacyProduct.productType));
};

export { getProductUrl };
//# sourceMappingURL=get-line-item-product-url.js.map
